import _ from 'underscore';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { BaseSchemaProcessor } from './base-schema-processor';
import { addCampaignTypePropertyForFilter } from '../util/update-campaign-type-property-for-filter';

// Most of the codes copied from private\summary-tabs\packages\search-term\src\filter-config.es
export class SearchTermSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = cloneDeep(entitySchema);

    // Omit Added as it has been replaced by SearchTermStatus
    updatedSchema.properties = _.omit(entitySchema.properties, ['Added']);

    // Search term does not support ViewThroughConversions
    updatedSchema.properties = _.omit(updatedSchema.properties, [
      'PerformanceMetricsViewThroughConversions',
      'PerformanceMetricsViewThroughConversionsRevenue',
      'PerformanceMetricsViewThroughConversionsCPA',
      'PerformanceMetricsViewThroughConversionsReturnOnAdSpend',
      'PerformanceMetricsViewThroughConversionsRate',
    ]);

    // make CampaignStatus and AdGroupStatus not show in filter menu.
    const campaignStatusProperty = updatedSchema.properties.CampaignStatus;
    const adgroupStatusProperty = updatedSchema.properties.AdGroupStatus;

    if (campaignStatusProperty) {
      campaignStatusProperty.filterable = false;
    }

    if (adgroupStatusProperty) {
      adgroupStatusProperty.filterable = false;
    }

    if (this.isForVNext) {
      updatedSchema.properties = _.omit(updatedSchema.properties, [
        'CampaignCampaignType',
      ]);

      addCampaignTypePropertyForFilter({
        entitySchema: updatedSchema, permissions: this.Permissions,
      });

      // Search term campaign type filer not supported for Dynamic, Audience, and Smart
      const supportedTypes = ["Enum.CampaignType'Default'", "Enum.CampaignType'Shopping'"];
      updatedSchema.properties.CampaignType.enum
        = _.filter(
          updatedSchema.properties.CampaignType.enum,
          type => supportedTypes.indexOf(type) >= 0
        );
    } else {
      // Remove duplicated word 'Campaign' in enum values of CampaignCampaignType
      const duplicatedString = 'Campaign';
      updatedSchema.properties.CampaignCampaignType.enum =
        _.map(updatedSchema.properties.CampaignCampaignType.enum, item => item.replace(duplicatedString, ''));
      // Search term campaign type filer not supported for Dynamic, Audience, and Smart
      const supportedTypes = ["Enum.CampaignType'Default'", "Enum.CampaignType'Shopping'"];
      updatedSchema.properties.CampaignCampaignType.enum =
        _.filter(
          updatedSchema.properties.CampaignCampaignType.enum,
          type => supportedTypes.indexOf(type) >= 0
        );
      const updatedEnumValueMap = {};
      _.each(updatedSchema.properties.CampaignCampaignType.enumValueMap, (val, key) => {
        updatedEnumValueMap[key.replace(duplicatedString, '')] = val;
      });
      updatedSchema.properties.CampaignCampaignType.enumValueMap = updatedEnumValueMap;
    }

    if (this.Permissions.IsSearchTermCloseVariantMatchTypeEnabled) {
      // hide old enum 'DeliveredMatchType'
      updatedSchema.properties = _.omit(updatedSchema.properties, 'DeliveredMatchType');

      // Delete deprecated enum value 'Content' for DeliveredMatchTypeWithCloseVariant
      const deletingNewEnumItem = "Enum.MatchTypeWithCloseVariant'Content'";
      updatedSchema.properties.DeliveredMatchTypeWithCloseVariant.enum = _.without(
        updatedSchema.properties.DeliveredMatchTypeWithCloseVariant.enum,
        deletingNewEnumItem
      );
      updatedSchema.properties.DeliveredMatchTypeWithCloseVariant.enumValueMap = _.omit(
        updatedSchema.properties.DeliveredMatchTypeWithCloseVariant.enumValueMap,
        deletingNewEnumItem
      );

      // format filter appearance
      updatedSchema.properties.DeliveredMatchTypeWithCloseVariant.enumValueMap["Enum.MatchTypeWithCloseVariant'ExactCloseVariant'"]
        = this.passedInI18n.getString('SearchTermMatchType_ExactCloseVariant');
      updatedSchema.properties.DeliveredMatchTypeWithCloseVariant.enumValueMap["Enum.MatchTypeWithCloseVariant'PhraseCloseVariant'"]
        = this.passedInI18n.getString('SearchTermMatchType_PhraseCloseVariant');
    } else {
      // hide old enum 'DeliveredMatchTypeWithCloseVariant'
      updatedSchema.properties = _.omit(updatedSchema.properties, 'DeliveredMatchTypeWithCloseVariant');

      // Delete deprecated enum value 'Content' for DeliveredMatchType
      const deletingEnumItem = "Enum.MatchType'Content'";
      updatedSchema.properties.DeliveredMatchType.enum =
        _.without(updatedSchema.properties.DeliveredMatchType.enum, deletingEnumItem);
      updatedSchema.properties.DeliveredMatchType.enumValueMap =
        _.omit(updatedSchema.properties.DeliveredMatchType.enumValueMap, deletingEnumItem);
    }

    const isPredictiveTargetingEnabled = this.Permissions && this.Permissions.dynamic && this.Permissions.dynamic.RSABidStrategyAutoTargeting;
    const isPredictiveMatchingEnabled = this.Permissions && this.Permissions.dynamic && this.Permissions.dynamic.PredictiveMatching;
    if (!isPredictiveTargetingEnabled && !isPredictiveMatchingEnabled) {
      if (updatedSchema.properties.DeliveredMatchTypeWithCloseVariant) {
        updatedSchema.properties.DeliveredMatchTypeWithCloseVariant.enum = _.without(updatedSchema.properties.DeliveredMatchTypeWithCloseVariant.enum, "Enum.MatchTypeWithCloseVariant'Predictive'");
      }
      if (updatedSchema.properties.MatchType) {
        updatedSchema.properties.MatchType.enum = _.without(updatedSchema.properties.MatchType.enum, "Enum.MatchType'Predictive'");
      }
    }

    return updatedSchema;
  }
}
